export { GuidePage as default, getStaticProps, getStaticPaths } from 'modules/guide/pages/GuidePage'

export const config = {
  unstable_JsPreload: false,
  unstable_runtimeJS: false,
}
